import Hero from './components/Hero';
import TrustStrip from './components/TrustStrip';
import Problem from './components/Problem';
import Solution from './components/Solution';
import IndustrySolutions from './components/IndustrySolutions';
import Process from './components/Process';
import CaseResults from './components/CaseResults';
import WhyDeluxe from './components/WhyDeluxe';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-[#0B0D10]">
      <Hero />
      <TrustStrip />
      <Problem />
      <Solution />
      <IndustrySolutions />
      <Process />
      <CaseResults />
      <WhyDeluxe />
      <FinalCTA />
      <Footer />
    </div>
  );
}